import React, {ReactNode} from 'react';
import {Box, Typography} from "@mui/material"
import InlineCode from "./InlineCode"

interface LabeledValueProps {
    label: string
    value: ReactNode
    mono?: boolean
    emphasize?: boolean
    error?: boolean
}

const labelSx = {
    textTransform: "uppercase",
    letterSpacing: "0.06em",
    fontWeight: 600,
    display: "block",
} as const

function LabeledValue({label, value, mono, emphasize, error}: LabeledValueProps) {
    return (
        <Box>
            <Typography variant="caption" color="text.secondary" sx={labelSx}>{label}</Typography>
            <Typography variant="body2"
                        component="div"
                        sx={{
                            whiteSpace: "pre-wrap",
                            wordBreak: "break-word",
                            fontWeight: emphasize ? 600 : 400,
                            color: error ? "error.main" : "text.primary",
                        }}>
                {mono ? <InlineCode>{value}</InlineCode> : value}
            </Typography>
        </Box>
    )
}

export default LabeledValue;
